import { Tour } from "antd";
import { useTourTargets } from "../hooks/useTourTargets";
import type { TourStepConfig } from "../types";

interface Props {
  open: boolean;
  onClose: () => void;
  steps: TourStepConfig[];
}

const OnboardingTour = ({ open, onClose, steps }: Props) => {
  const resolvedSteps = useTourTargets(steps);

  return (
    <Tour
      open={open}
      onClose={onClose}
      steps={resolvedSteps}
      indicatorsRender={(current, total) => `${current + 1} / ${total}`}
    />
  );
};

export default OnboardingTour;
